import * as $ from "jquery";
import "datatables.net";

import { ViewRenderer } from "../ah.mb.ui.view-builders";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";


    /**

     * Attachments table def
     */
    export class AttachmentsTableRenderer implements ViewRenderer {

        private table: DataTables.Api;
        private ajaxSettings: DataTables.AjaxSettings;

        forceViewType(chartSeriesTypeId: number): void {
            // Not implemented
        }

        /**
         * Ctor
         */
        constructor(ajaxSettings: DataTables.AjaxSettings) {
            this.ajaxSettings = ajaxSettings;
        }


        /**
         * Before render
         * @param target
         * @param viewName
         */
        public beforeRender(target: JQuery, viewName: string) {

        }

        /**
         * After render
         * @param target
         * @param viewName
         */
        public afterRender(target: JQuery, viewName: string) {

        }

        /**
         * Renders the view
         * @param target
         * @param data
         */
        public render = (target: JQuery, data: any): void => {

            if (this.table)
                this.refresh();
            else {
                const tableSettings = this.getTableSettings(this.ajaxSettings);
                this.table = target.DataTable(tableSettings);
            }
        }

        /**
         * Refreshes the view
         */
        public refresh() {
            this.table.ajax.reload();
        }

    /**
     * Returns datatable settings
     * @param ajaxSettings
     */
        getTableSettings(ajaxSettings: DataTables.AjaxSettings): DataTables.Settings
        {
            const columnDefs: Array<DataTables.ColumnSettings> = [
                {
                    //"title": "id",
                    data: "id",
                    visible: false
                },

                {
                    title: "Name",
                    data: "name",
                    width: "40%",
                    render: (data, type, oObj) => {
                        const modelId = oObj.modelId;
                        const id = oObj.id;
                        const name = data;
                        const html = ` <a href=\"\/api/1.0/attachments/download?modelId=${modelId}&attachmentId=${id}" download><strong>${name}</strong></a>`;

                        return html;
                    }
                },
                {
                    title: "Uploaded By",
                    data: "uploadedBy",
                    width: "20%"
                },
                {
                    title: "Date Uploaded",
                    data: "uploadDateTime",
                    width: "20%",
                    render: (data => new Date(data).toLocaleDateString())
                },
                {
                    title: "Size",
                    // data: 4,
                    data: "fileLength",
                    width: "20%",
                    render: (data) => {
                        return this.formatSizeUnits(data);
                    }
                },
                {
                    title: "Options",
                    width: "20%",
                    orderable: false,
                    searchable: false,

                    render: (data, type, oObj) => {
                        const html = `<button class="btn btn-xs btn-danger deleteAttachmentBtn" data-objectId="${oObj.id}" data-modelId="${oObj.modelId}" 
                            data-name="${oObj.name}">Delete</button>`;

                        return html;
                    }

                }
            ];

            const defaultOrder = [1, "asc"];

            const settings: DataTables.Settings = {
                ajax: ajaxSettings,
                processing: false,
                serverSide: true,
                //    filter: true,
                autoWidth: true,
                searching: true,
                paging: true,
                pageLength: 10,
                columns: columnDefs,
                order: defaultOrder,
                drawCallback: this.tableDrawCallback,

                //// For 24-cell grid system
                //dom: "<'row'<'col-sm-12'l><'col-sm-12'f>>" +
                //    "<'row'<'col-sm-24'tr>>" +
                //"<'row'<'col-sm-10'i><'col-sm-4'p>>",

                // For nicer search caption
                "language": {
                    "search": "<span>Search: </span> _INPUT_" //search
                }


            };

            return settings;

        }

        private formatSizeUnits(bytes): string{
        if (bytes >= 1000000000) { bytes = (bytes / 1000000000).toFixed(2) + " GB"; }
        else if (bytes >= 1000000) { bytes = (bytes / 1000000).toFixed(2) + " MB"; }
        else if (bytes >= 1000) { bytes = (bytes / 1000).toFixed(2) + " KB"; }
        else if (bytes > 1) { bytes = bytes + " bytes"; }
        else if (bytes === 1) { bytes = bytes + " byte"; }
        else { bytes = "0 byte"; }
        return bytes;
    }


        /**
         * Table draw callback
         * @param settings
         */
        private tableDrawCallback = (settings: DataTables.Settings):void => {

            // Todo: Fix callback


            // Setup row delete button clicks
            $(".deleteAttachmentBtn")
                .click((e) => {

                    var modelId = e.currentTarget.getAttribute("data-modelId");
                    var attachmentId = e.currentTarget.getAttribute("data-objectId");
                    var attachmentName = e.currentTarget.getAttribute("data-name");


                    //var modelId = $(e.target).attr("data-modelId");
//                    var attachmentId = $(e.target).attr("data-objectId");
  //                  var name = $(e.target).attr("data-name");

                    bootbox.confirm(`Delete ${attachmentName}?`,
                        (ok: boolean) => {
                            if (ok) {

                                FetchWrapper.sendCommandAndHandle("/api/1.0/attachments/delete",
                                    {
                                        method: "post",
                                        body: JSON.stringify({
                                            modelId: modelId,
                                            attachmentIds: [attachmentId]
                                        })
                                    })
                                    .then((data) => {
                                            this.refresh();
                                });
                            }

                        }
                    );
                });


        }
    }





// WEBPACK FOOTER //
// ./ClientApp/scripts/attachments/ah.mb.attachments-table.ts